import React from 'react';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../../routes';
import './BannerPremium.scss';

const BannerPremium = () => {

  const history = useHistory()
  
  const handleSubmit = () => {
    history.push(ROUTES.MEMBERSHIPS_LAWYERS)
  };

  return (
    <div className='bannerPremium' onClick={handleSubmit}>
      <div className='bannerPremium_container1'>
        <p className='bannerPremium_text1'>
          Contacta Abogado® <span className='bannerPremium_premiumBadge'>PREMIUM</span> te brinda las herramientas 
          para impulsar tus servicios en línea y conseguir más clientes.
        </p>
      </div>
      <div className='bannerPremium_container2'>
        <p className='bannerPremium_text2'>
          Da click aquí y mejora tu plan
        </p>
      </div>
    </div>
  );
};

export default BannerPremium;
